import HttpAxios from "./base";

// 提交时，过滤参数，添加翻页的起始页
const addPageStart = function(data) {
  if (!data) return data;
  if (data && data.paging) {
    data.paging.start = (data.paging.page - 1) * data.paging.limit + 1;
    return data;
  } else {
    return data;
  }
};
const Http = {
  /**
   * @description: POST请求 如果要在url里加参数，就在最后一个里面加，情况比较少，但总是会有这种后台开发者，搞一些神奇的接口组合
   */
  POST: (apiUrl, data, option, params) => {
    return HttpAxios.commonApi(
      {
        url: apiUrl,
        method: "POST",
        params: addPageStart(params),
        data: addPageStart(data),
      },
      option
    );
  },
  /**
   * @description: GET请求 如果要在body里加参数，就在最后一个里面加，情况比较少
   */
  GET: (apiUrl, params, option, data) => {
    return HttpAxios.commonApi(
      {
        url: apiUrl,
        method: "GET",
        params: addPageStart(params),
        data: addPageStart(data),
      },
      option
    );
  },
  /**
   * @description: 读卡机读身份证信息
   */
  READCARD: (apiUrl, params, option) => {
    return HttpAxios.readcardApi(
      {
        url: apiUrl,
        method: "GET",
        params,
      },
      option
    );
  },
  /**
   * @description: 上传文件请求
   */
  Upload: (apiUrl, params) => {
    return HttpAxios.uploadFiles(apiUrl, params);
  },
  /**
   * @description: 导出
   */
  Export: (apiUrl, data, params) => {
    console.log(apiUrl);
    return HttpAxios.exportTable(apiUrl, data, params);
  },
};

export default Http;
